export class refreshTokenModel {
	
    accessToken : string;
    refreshToken : string;
 
	constructor() {
		this.accessToken = '';
		this.refreshToken = '';
	}

	public convert(): any {
		return {
			accessToken : this.accessToken,
			refreshToken : this.refreshToken,
		};
	}

	public clone(source: any): refreshTokenModel {

        if (source.accessToken != (null || undefined)) {
			this.accessToken = source.accessToken;
		}

		if (source.refreshToken != (null || undefined)) {
			this.refreshToken = source.refreshToken;
		}

		return this;
	}
}
